import { render, staticRenderFns } from "./TranslateChooseAudio.vue?vue&type=template&id=6208f1e2&scoped=true&"
import script from "./TranslateChooseAudio.vue?vue&type=script&lang=js&"
export * from "./TranslateChooseAudio.vue?vue&type=script&lang=js&"
import style0 from "./TranslateChooseAudio.vue?vue&type=style&index=0&id=6208f1e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6208f1e2",
  null
  
)

export default component.exports